module.exports = __webpack_public_path__ + "img/Mangystau.3146405d.png";